import React, { useState } from 'react';
import { Card, Typography, Button, Space, List, Tag } from 'antd';
import { MedicineBoxOutlined, MonitorOutlined, CheckOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';
import { logEvent } from '../../analytics';

const { Text, Paragraph } = Typography;

const NoteDrugInteractions = ({ note, source }) => {
  const { t } = useTranslation();  
  const medicationStrings = note?.getActiveMedicationStrings() || [];
  const hasMedications = medicationStrings.length > 0;
  const patient = source.getPatient();

  const handleOpenDrugInteractionsPanel = () => {
    // Dispatch custom event to open tools panel with medications data
    const event = new CustomEvent('openToolsPanel', {
      detail: {
        tool: 'drug-interactions',
        medications: medicationStrings,
        patientUuid: source.getPatient()?.getUUID() || null
      }
    });
    window.dispatchEvent(event);
    
    logEvent('SessionDetails', 'ViewDrugInteractions');
  };

  const cardTitle = (
    <div>
      <MedicineBoxOutlined style={{ marginRight: '8px' }} />
      <Text style={{ fontSize: '16px', marginRight: '8px' }}>
        {t('drug_interactions.title')}
      </Text>
      <Tag color="green" style={{ fontSize: '12px', padding: '2px 4px', lineHeight: '1', backgroundColor: '#52c41a', color: 'white', border: '2px solid #52c41a' }}>
        {t('common.new')}
      </Tag>
    </div>
  );

  return (
    <Card
      title={cardTitle}
      style={{
        background: 'white',
        border: '1px solid #f0f0f0',
        marginTop: '10px',
        marginBottom: '4px'
      }}
    >
      <div className="drug-interactions">
        {hasMedications ? (
          <Space direction="vertical" size="small" style={{ width: '100%' }}>
            <div>
              <Paragraph type="secondary" style={{ fontSize: '14px' }}>
                {t('drug_interactions.mentioned_medications')}
              </Paragraph>
              <List
                dataSource={medicationStrings}
                listStyle="circle"
                renderItem={(medication, index) => (
                  <List.Item style={{ padding: '4px 0' }}>
                    <Text style={{ fontSize: '14px', fontStyle: 'italic' }}>
                      {medication}
                    </Text>
                  </List.Item>
                )}
              />
            </div>

            <Button
              icon={<MonitorOutlined />}
              type="default"
              onClick={handleOpenDrugInteractionsPanel}
              disabled={!hasMedications}
              style={{ marginTop: '12px' }}
            >
              {t('drug_interactions.check_interactions')}
            </Button>
            {!patient && <Paragraph type="secondary" style={{ fontSize: '14px', fontStyle: 'italic', marginTop: '12px', marginBottom: '-10px' }}>
              {t('drug_interactions.note_interactions_description')}
            </Paragraph>}
          </Space>
        ) : (
          <Space direction="vertical" size="small" style={{ width: '100%' }}>
            <div style={{ textAlign: 'center', padding: '20px 0' }}>
              <Text type="secondary" style={{ display: 'block', marginBottom: '12px' }}>
                {t('drug_interactions.no_medications')}
              </Text>
              <Button
                type="primary"
                size="small"
                icon={<CheckOutlined />}
                onClick={handleOpenDrugInteractionsPanel}
              >
                {t('drug_interactions.check_interactions')}
              </Button>
            </div>
          </Space>
        )}
      </div>
    </Card>
  );
};

export default NoteDrugInteractions; 